module.exports = __webpack_public_path__ + "static/media/nb_akademie_italic-webfont.1069b3d9.ttf";